import { Box, Icon, Paragraph } from '@zillow/constellation-10';
import { IconCheckmarkCircleFilled } from '@zillow/constellation-icons';

export const SavedIndicator = () => {
  return (
    <Box css={{ display: 'flex', alignItems: 'center', gap: 'tighter' }}>
      <Paragraph textStyle="body-sm" css={{ color: 'text.feedback.success.hero' }}>
        Saved
      </Paragraph>
      <Icon css={{ color: 'text.feedback.success.hero' }} size="sm">
        <IconCheckmarkCircleFilled />
      </Icon>
    </Box>
  );
};
